@if (ticket) {
  <div class="ticket-layout-details-dialog" mat-dialog-content>
    <div class="dialog-header">
      <div class="dialog-title-custom">
        @if(isNotClaimed()){
          {{ "APP.TICKETS_DASHBOARD.GUEST_DATA" | translate }}
        }@else{
          {{ "APP.TICKETS_DASHBOARD.OWNER_DATA" | translate }}
        }
      </div>
    </div>
    <div class="dialog-body">
      <div class="owner-data">
        <app-user-avatar
          class="avatar"
          [user]="ticket.eventAttendee?.userFull || ticket.eventAttendee?.user"
          [size]="64"
          [placeholderFontSize]="24"
          [fallbackInitials]="ticket.eventAttendee?.getFallbackInitials()"
        >
        </app-user-avatar>
        <div class="owner-info">
          <div class="owner-name">
            @if(ticket.eventAttendee?.getName()){
              {{ ticket.eventAttendee?.getName() }}
            }@else{
              {{ "APP.DATA_MISSING" | translate }}
            }
            </div>
          <div class="owner-email">{{ ticket.eventAttendee?.getEmail() }}</div>
        </div>
        <div class="status">
          @if (ticket.isUsed) {
            <div class="status used">
              <i class="fa-regular fa-circle-check icon-medium"></i>
            </div>
          }
          @else if(isNotClaimed()){
            <div class="status not-claimed">
              <i class="fa-regular fa-hourglass-half"></i>
            </div>
          }@else {
            <div class="status">
              <i class="fa-regular fa-ban icon-medium"></i>
            </div>
          }
        </div>
      </div>
      <div class="ticket-data-cont">
        @if(!isNotClaimed()){
          <div class="ticket-data-item">
            <div class="label">
              {{ "APP.TICKETS_DASHBOARD.TICKET_BOUGHT" | translate }}
            </div>
            <div class="data">{{ ticket.getDatePaidDisplay() }}</div>
          </div>
          <div class="ticket-data-item">
            <div class="label">
              {{ "APP.TICKETS_DASHBOARD.CHECKED_IN" | translate }}
            </div>
            <div class="data">{{ ticket.getCheckedInInfo() }}</div>
          </div>
        }@else{
        <div class="ticket-data-item">
          <div class="label">
            {{ "APP.STATUS" | translate }}
          </div>
          <div class="data">{{ "APP.TICKETS_DASHBOARD.NOT_CLAIMED_YET" | translate }}</div>
        </div>
        <div class="ticket-data-item">
          <div class="label">
            {{ "APP.TICKETS_DASHBOARD.PURCHASE_DATE" | translate }}
          </div>
          <div class="data">{{ ticket.getDatePaidDisplay() }}</div>
        </div>
        }

      </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
      @if (isNotClaimed()){
        <button class="btn btn-primary" (click)="sendReminder()">
          {{ "APP.TICKETS_DASHBOARD.SEND_REMINDER" | translate }}
        </button>
      }
      <button class="btn btn-primary-text" (click)="close()">
        {{ "APP.CLOSE" | translate }}
      </button>
    </div>
  </div>
}
